import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M15.4291 10.23H3.98706L9.72906 2.40796L15.4291 10.23Z" fill="currentColor" />
    <path d="M19.4901 21.487H8.2251V10.231H11.2251V18.487H19.4901V21.487Z" fill="currentColor" />
  </>
);

const Icon = createSvgIcon(svg, 'ArrowLevelUpFill');

export default Icon;
